import { render } from "./ProductosOfertaView.vue?vue&type=template&id=0accb8b2"
import script from "./ProductosOfertaView.vue?vue&type=script&lang=js"
export * from "./ProductosOfertaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__